<script>
import Layout from "../../layouts/print";
import appConfig from "@/app.config";
//import { saleService } from "../../../services/saleservice/sale.service";


/* eslint-disable no-console */
export default {
  page: {
    title: "Expence Request",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
     allData: {}
      
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    
  },
  methods: {
    
    loadingData: function(id) {
      
      alert(id);
      

    }
  },
};

</script>

<template>
  <Layout>
    
        <center>
          <div class="col dblack box-a4-long">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="14%"><p>&nbsp;</p></td>
                <td width="86%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khm h6">លំនៅឋាន អេចស៊ី ឯ.ក</p>
                  <p class="enb h6">LOMNOV THAN HC CO., LTD</p>
                  <p class="khs h7">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h7">ទូរស័ព្ទលេខៈ 078 554 077 | 015 554 077 Email: account@h-residence.net</p>
                </td>
              </tr>
              <tr><td colspan="2"><div class="hr-2"></div></td></tr>
            </table>
            <br/>
            <table width="100%" class="content-general">
              <tr>
                <td width="20%"></td>
                <td width="60%" class="center">
                  <p class="h5 khm">សក្ខីប័ត្រចំណាយ</p>
                  <p class="h5 enb">PAYMENT VOUCHER</p>
                </td>
                <td width="20%">
                  <p class="en">RHSS-No . . . . . . . . . . .</p>
                  <p class="khs">ថ្ងៃទី . . . . ខែ . . . . ឆ្នាំ20 . . .</p>
                </td>
              </tr>
              
              </table>
            <br>

            <table class="content-general h6 left" width="100%">
              <tr>
                <td width="50%"><p class="khs">បានទទាត់ប្រាក់ជូន<span class="en">/Paid To:</span></p></td>
                <td width="50%"><p class="khs">លេខទូរស័ព្ទ<span class="en">/Phone No:</span></p></td>
              </tr>
              <tr>
                <td width="50%"><p class="khs">ចំនួនទឹកប្រាក់<span class="en">/Amount:</span></p></td>
                <td width="50%"><p class="khs">យោងសក្ខីប័ត្រ<span class="en">/Reference No:</span></p></td>
              </tr>
              <tr>
                <td colspan="2"><p class="khs">ចំនួនទឹកប្រាក់ជាអក្សរ<span class="en">/Amount in Word:</span></p></td>
              </tr>
            </table>
            <br>
            <table class="content-general h6 schedule-table" width="100%" border="1">
              
                <tr class="thead">
                  <td><p class="khs">ល.រ</p></td>
                  <td><p class="khs">បរិយាយ</p></td>
                  <td><p class="khs">ចំនួន</p></td>
                  <td><p class="khs">តម្លៃរាយ</p></td>
                  <td><p class="khs">សម្លៃសរុប</p></td>
                </tr>
              <tbody>
                
              </tbody>
            </table>
            <br>
            <table class="content-general h6 center" width="100%" border="1">
              <tr>
                <td>
                  <p class="khs">
                    វិធីទូទាត់ <span class="en">/Payment Method</span>
                    <span class="h2">&squ;</span>សាច់ប្រាក់ <span class="en">/Cash</span>
                    <span class="h2">&squ;</span>មូលប្បទានប័ត្រ <span class="en">/Cheque</span>
                    <span class="h2">&squ;</span>ផ្ទេចូលគណនីធនាគារ <span class="en">/Bank Transfer</span>
                  </p>
                </td>
              </tr>
            </table>
            <br>
            <table class="content-general h6 center" width="100%">
              <tr>
                <td>
                  <p class="khm">ប្រធានគ្រប់គ្រង <span class="en">/Manager</span></p>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <p class="khs"> . . . . . . . . . . . . . . . . . . . . . . .</p>
                  <p class="khs">ថ្ងៃទី . . . . . . . . . . . . . . . . . . . .</p>
                </td>
                <td>
                  <p class="khm">អ្នកទទួលប្រាក់ <span class="en">/Receiver</span></p>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <p class="khs"> . . . . . . . . . . . . . . . . . . . . . . .</p>
                  <p class="khs">ថ្ងៃទី . . . . . . . . . . . . . . . . . . . .</p>
                </td>
                <td>
                  <p class="khm">គណនេយ្យករ <span class="en">/Accountant</span></p>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <p class="khs"> . . . . . . . . . . . . . . . . . . . . . . .</p>
                  <p class="khs">ថ្ងៃទី . . . . . . . . . . . . . . . . . . . .</p>
                </td>
              </tr>
              
            </table>
          </div>
        </center>
  </Layout>
</template>